// Cache voor jaaraggregaat-resultaten. Sleutel = stabiele hash van het
// schaduwrelevante deel van het scenario (zie §3.6, "alleen herrekenen
// als geometrie of locatie verandert"). Maximum 20 entries — beyond
// that we evict de oudste (op `computedAt`).

import { getDb } from "./indexedDb";
import type { YearAggregateResult } from "../shadow/yearAggregate";

const STORE = "yearResults";
const MAX_ENTRIES = 20;

export async function getCachedYearResult(
  scenarioHash: string,
): Promise<YearAggregateResult | undefined> {
  try {
    const db = await getDb();
    const v = await db.get(STORE, scenarioHash);
    return v as YearAggregateResult | undefined;
  } catch (err) {
    console.warn("[cache] getCachedYearResult failed:", err);
    return undefined;
  }
}

export async function putCachedYearResult(result: YearAggregateResult): Promise<void> {
  try {
    const db = await getDb();
    await db.put(STORE, result);
    await evictIfNeeded();
  } catch (err) {
    console.warn("[cache] putCachedYearResult failed:", err);
  }
}

async function evictIfNeeded(): Promise<void> {
  const db = await getDb();
  const all = (await db.getAll(STORE)) as YearAggregateResult[];
  if (all.length <= MAX_ENTRIES) return;
  // Sort op computedAt asc; verwijder de oudste tot we onder de limiet zitten.
  all.sort((a, b) => a.computedAt.localeCompare(b.computedAt));
  const tx = db.transaction(STORE, "readwrite");
  const toRemove = all.length - MAX_ENTRIES;
  for (let i = 0; i < toRemove; i++) {
    await tx.store.delete(all[i].scenarioHash);
  }
  await tx.done;
}
